import React from 'react';

import { Box, Container, Typography, Grid, Divider } from '@mui/material';

const LandingPage = () => {
	return (
		<Box component="footer" sx={{ py: 4, bgcolor: '#212121', color: 'white' }}>
			<Container maxWidth="lg">
				<Grid container spacing={2}>
					<Grid>
						<Typography variant="h6" fontWeight="bold">
							Meistro
						</Typography>
						<Typography variant="body2" color="#b0b0b0">
							Your memories, safe and searchable. Built for the modern archiver.
						</Typography>
					</Grid>

					<Grid>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
							<Typography variant="body2" fontWeight="bold">
								Product
							</Typography>
							<Typography variant="body2" color="#b0b0b0">
								Features
							</Typography>
							<Typography variant="body2" color="#b0b0b0">
								Pricing
							</Typography>
						</Box>
					</Grid>

					<Grid>
						<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
							<Typography variant="body2" fontWeight="bold">
								Support
							</Typography>
							<Typography variant="body2" color="#b0b0b0">
								Privacy Policy
							</Typography>
							<Typography variant="body2" color="#b0b0b0">
								Terms of Service
							</Typography>
						</Box>
					</Grid>
				</Grid>

				<Divider sx={{ my: 4, bgcolor: '#616161', height: 'auto' }} />

				<Typography variant="body2" color="#b0b0b0" align="center">
					© {new Date().getFullYear()} Meistro. All rights reserved. Built on
					AWS.
				</Typography>
			</Container>
		</Box>
	);
};

export default LandingPage;
